/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

const React = require("react")
const { getAnalytics } = require("./src/utils/analytics")

exports.onRouteUpdate = () => {
  window.requestAnimationFrame(() => getAnalytics().trackPageView())
}

// Wrap root element with Strict Mode to catch issues
exports.wrapRootElement = ({ element }) => {
  return React.createElement(React.StrictMode, null, element)
}

// Force React to show hydration warnings in console
exports.onClientEntry = () => {
  if (typeof window !== "undefined") {
    const originalError = console.error
    const originalWarn = console.warn
    
    console.error = (...args) => {
      if (
        typeof args[0] === "string" &&
        (args[0].includes("Hydration") ||
          args[0].includes("did not match") ||
          args[0].includes("Warning: Text content") ||
          args[0].includes("Warning: Expected server") ||
          args[0].includes("Minified React error #418") ||
          args[0].includes("Minified React error #423") ||
          args[0].includes("Minified React error #425"))
      ) {
        // Make hydration errors more visible
        console.group("🔴 HYDRATION ERROR DETECTED")
        originalError.apply(console, args)
        console.trace("Stack trace:")
        console.groupEnd()
        return
      }
      originalError.apply(console, args)
    }

    console.warn = (...args) => {
      if (
        typeof args[0] === "string" &&
        (args[0].includes("Hydration") ||
          args[0].includes("did not match"))
      ) {
        console.group("⚠️ HYDRATION WARNING")
        originalWarn.apply(console, args)
        console.trace("Stack trace:")
        console.groupEnd()
        return
      }
      originalWarn.apply(console, args)
    }

    console.log("✅ Hydration error detection enabled")
  }
}
